export default __webpack_public_path__ + "static/media/tune_upwards3.9b5a9994.jpg";